import { features } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            为什么选择<span className="text-accent-500">51cg</span>吃瓜
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            五大核心优势，让你吃得明明白白
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="group relative p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-accent-300/60 transition-all duration-300 cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 group-hover:bg-accent-200/80 transition-colors duration-300 mb-4">
                <i className={`${item.icon} text-accent-600 text-lg`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}